import Delayed from './delayed.component';
export default Delayed;
